import {
  Avatar,
  Button,
  Flex,
  ScrollArea,
  Text,
  UnstyledButton,
} from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';

import type { CandidatePickCard } from '../../types';

import classes from './candidate-pick-drawer.module.scss';

type CandidatePickListViewProps = {
  candidates: CandidatePickCard[];
  currentIndex: number;
  vacantPlaces: number;
  onBack: () => void;
  onSelect: (index: number) => void;
};

export const CandidatePickListView = ({
  candidates,
  currentIndex,
  vacantPlaces,
  onBack,
  onSelect,
}: CandidatePickListViewProps) => {
  return (
    <Flex direction='column' gap={24} flex={1} miw={0} mih={0} w='100%'>
      <Flex
        align='center'
        justify='space-between'
        gap={16}
        wrap='wrap'
        className={classes.listHeader}
      >
        <Button
          type='button'
          variant='outline'
          size='md'
          leftSection={<IconArrowLeft size={20} />}
          onClick={onBack}
        >
          Вернуться
        </Button>

        <Flex gap={16} wrap='wrap' align='center'>
          <Text size='sm' c='tertiary.7'>
            Кандидатов: {candidates.length}
          </Text>
          <Text size='sm' c='tertiary.7'>
            Вакантных мест:{' '}
            <Text span inherit fw={600} c='primary.7'>
              {Math.max(vacantPlaces, 0)}
            </Text>
          </Text>
        </Flex>
      </Flex>

      <ScrollArea flex={1} type='auto' offsetScrollbars>
        <Flex direction='column' gap={8} pb={8}>
          {candidates.map((candidate, index) => (
            <UnstyledButton
              key={candidate.candidateId}
              type='button'
              className={classes.listItem}
              data-active={index === currentIndex}
              onClick={() => onSelect(index)}
            >
              <Flex gap={12} align='center' wrap='nowrap'>
                <Avatar
                  src={candidate.photoUrl || undefined}
                  name={`${candidate.firstName} ${candidate.lastName}`}
                  radius='50%'
                  size={40}
                  flex='0 0 auto'
                />
                <Flex
                  direction='column'
                  gap={4}
                  align='flex-start'
                  style={{ flex: 1, minWidth: 0 }}
                >
                  <Text size='md' fw={600} c='primary.7' lineClamp={1}>
                    {candidate.displayName}
                  </Text>
                  <Flex gap={8} align='center' wrap='wrap'>
                    <Text size='sm' c='tertiary.7'>
                      {candidate.phone}
                    </Text>
                    <Text size='sm' c='tertiary.7'>
                      {candidate.readyToWorkDate}
                    </Text>
                  </Flex>
                </Flex>
              </Flex>
            </UnstyledButton>
          ))}
        </Flex>
      </ScrollArea>
    </Flex>
  );
};
